// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__2lh3_","Mask":"Hero_Mask__3nuju","Image":"Hero_Image__1ogi7","Description":"Hero_Description__1jm98"};